import { Box, Typography } from '@mui/material';

interface OperationsBlockProps {
  blockHeader: string;
  children: React.ReactNode;
}

export function OperationsBlock({ blockHeader, children }: OperationsBlockProps) {
  return (
    <Box sx={{ flexGrow: 1, mb: 3 }}>
      <Typography
        variant="subtitle2"
        sx={{
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          mb: 1,
          px: 1,
          color: 'text.secondary',
        }}
      >
        {blockHeader}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
